<template lang="pug">
.multiload
    SvButton.multiload__button(
        view="bordered"
        text="Загрузить"
    )

    input.multiload__input(
        type="file"
        multiple="true"
        @change="uploadImages"
    )
</template>

<script>
import SvButton from '@/components/uikit/SvButton.vue';

export default {
  name: 'MultiLoad',

  components: {
    SvButton,
  },

  methods: {
    uploadImages(val) {
      const result = []; // Массив результата

      // Цикл по всем файлам
      for (let i = 0; i < val.target.files.length; i += 1) {
        result.push(this.base64Image(val.target.files[i]));
      }
      Promise.all(result).then(res => this.$emit('uploaded', res));
    },

    base64Image(image) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = () => {
          resolve(reader.result);
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.multiload {
    position: relative;
    width: 140px;

    &__input {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
        bottom: 0;
        right: 0;
        cursor: pointer;
    }

    &__button {
        width: 140px;
    }
}
</style>
